// extracted by mini-css-extract-plugin
export var date = "upcomingEvents-module--date--f1469";
export var event = "upcomingEvents-module--event--cd475";
export var event_list = "upcomingEvents-module--event_list--3720e";
export var month = "upcomingEvents-module--month--eced4";
export var more_link = "upcomingEvents-module--more_link--c7240";
export var more_links = "upcomingEvents-module--more_links--df1a2";